module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jvIqYr/images/9780292747975.jpg?1690753925343",
      "alt": "This image is the cover for the book Indians of Texas, Texas History Paperbacks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Indians of Texas, Texas History Paperbacks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An anthropological history of Native Americans in the Lone Star State.")]), _c('br'), _c('br'), _vm._v("First published in 1961, this study explores the ethnography of the Indian tribes who lived in the region that is now the state of Texas since the beginning of the historic period. "), _c('br'), _c('br'), _vm._v("The tribes covered include:CoahuiltecansKarankawasLipan ApachesTonkawasComanches;Kiowas and Kiowa ApachesJumanosWichitasCaddosAtakapans"), _c('br'), _c('br'), _c('b', [_vm._v("“Newcomb’s book is likely to remain the best general work on Texas Indians for a long time.” —"), _c('i', [_vm._v("American Antiquity")])]), _c('br'), _c('br'), _c('b', [_vm._v("“An excellent and long-needed survey of the ethnography of the Indian tribes who resided within the present limits of Texas since the beginning of the historic period. . . . The book is the most comprehensive. scholarly, and authoritative account covering all the Indians of Texas, and is an invaluable and indispensable reference for students of Texas history, for anthropologists, and for lovers of Indian lore.” —"), _c('i', [_vm._v("Ethnohistory")])]), _c('br'), _c('br'), _c('b', [_vm._v("“Dr. Newcomb writes persuasively and with economy, and he has used his material very well indeed. . . . His presentation makes good reading of what might have been a book only for the specialists.” —"), _c('i', [_vm._v("Saturday Review")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      W.W. Newcomb\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    University of Texas Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0